import React from 'react';
import SortableBase from 'react-sortablejs';

const Sortable = (props) => <SortableBase {...props} />;

export default Sortable;
